(() => {
  function activateStage(section, stageId) {
    const stages = section.querySelectorAll(
      '[data-brand-builder-stage]'
    );

    const visuals = section.querySelectorAll(
      '[data-brand-builder-visual]'
    );

    stages.forEach((stage) => {
      const isActive =
        stage.dataset.brandBuilderStage === stageId;

      stage.classList.toggle('is-active', isActive);

      const trigger = stage.querySelector(
        '[data-brand-builder-trigger]'
      );

      if (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          String(isActive)
        );
      }
    });

    visuals.forEach((visual) => {
      const isActive =
        visual.dataset.brandBuilderVisual === stageId;

      visual.classList.toggle('is-active', isActive);

      visual.setAttribute(
        'aria-hidden',
        String(!isActive)
      );
    });
  }

  function initBrandBuilder(section) {
    if (section.dataset.brandBuilderInitialised === 'true') {
      return;
    }

    section.dataset.brandBuilderInitialised = 'true';

    const triggers = section.querySelectorAll(
      '[data-brand-builder-trigger]'
    );

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const stageId =
          trigger.dataset.brandBuilderTrigger;

        activateStage(section, stageId);
      });
    });
  }

  document
    .querySelectorAll('[data-brand-builder]')
    .forEach(initBrandBuilder);

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      event.target
        .querySelectorAll('[data-brand-builder]')
        .forEach(initBrandBuilder);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const section =
        event.target.closest('[data-brand-builder]');

      if (!section) {
        return;
      }

      const stage = event.target.closest(
        '[data-brand-builder-stage]'
      );

      if (!stage) {
        return;
      }

      activateStage(
        section,
        stage.dataset.brandBuilderStage
      );
    }
  );
})();